import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { CassaService, IRicercaCassaParams } from '@app/shared/services/cassa.service';

@Component({
  selector: 'tig-cassa-select',
  templateUrl: './cassa-select.component.html',
  styleUrls: ['./cassa-select.component.scss']
})
export class CassaSelectComponent {

  @Input() set idStazione(newValue: string) {
    if (newValue) {
      this.cassaService.idPath = newValue;
      this.search(newValue);
    }
  }

  @Input() control: UntypedFormControl;
  @Input() label: string = "casse.title.dettaglio";
  @Input() bindAllObject: boolean = false;

  casse: IS1InputSelectItem[]

  constructor(private cassaService: CassaService) { }

  search(idStazione: string) {

    const params: IRicercaCassaParams = {
      page: 1,
      pageSize: 999,
      sortBy: "id",
      idStazione: idStazione
    }
  
    this.cassaService.ricercaCasse(params).subscribe(cassePaginate => {

      this.casse = cassePaginate?.elements?.map(cassa => { 
        return { code: cassa.id, label: cassa.codice?.trim() }  
      }) ?? [];
  
      if (this.casse?.length == 1) {
        this.control?.patchValue(this.bindAllObject? this.casse[0] : this.casse[0].code);
      }
  
    })

  }

}
